export default {
    CREATE_DRAFT: () => '/draft',
    GET_BY_ID_DRAFT: (id) => `/draft/${id}`,
    GET_ALL_DRAFT: () => `/draft`,
    DELETE_BY_ID_DRAFT: (id) => `/draft/${id}`,
    UPDATE_DRAFT: (id) => `/draft/${id}`,
    GET_BY_GMAILMSGID :(id)=>`/draft/getByMessageId/${id}`
};
